@let value = $value() !== undefined ? $_value() : $controlValue();
@let disabled = $disabled() !== undefined ? $disabled() : $controlDisabled();
@let readonly = $readonly();
@let controlPosition = $controlPosition();
@let verticalAlignment = $verticalAlignment() === 'center' ? 'items-center' : $verticalAlignment() === 'start' ? 'items-start' : 'items-end';
<label
  [class]="'px-1 flex' + (controlPosition === 'default' || controlPosition === 'opposite' ? ' items-start' : ' flex-col ' + verticalAlignment)"
  [style.padding]="$innerPadding()"
  [style.gap]="$gap() | cssValue"
  [class.disab]="disabled"
  [class.readonly]="readonly"
  [matTooltip]="!disabled ? $tooltip() : $tooltipWhenDisabled()"
>
  @if ($label() !== null) {
  <p
    [class]="(readonly ? '' : 'select-none') + ($labelWrap() ? '' : ' whitespace-nowrap') + (controlPosition === 'opposite' || controlPosition === 'top' ? ' order-1' : '')"
    [style.fontSize]="$labelFontSize() | cssValue"
    [style.fontWeight]="$labelWeight()"
    [style.color]="'var(' + $labelColor() + ')'"
  >{{ $label() }}</p>
  }
  <textarea
    class="input"
    [value]="value"
    [placeholder]="$placeholder()"
    [style.fontSize]="$inputFontSize() | cssValue"
    [style.width]="$inputWidth()"
    [style.resize]="$resize()"
    [rows]="$rows()"
    [attr.cols]="$cols()"
    [disabled]="disabled || readonly"
    (input)="onValueChange($event)"
  ></textarea>
</label>
